import { render } from "./lang-input.vue?vue&type=template&id=0540a59a"
import script from "./lang-input.vue?vue&type=script&lang=js"
export * from "./lang-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__